import { marked } from 'marked'
import i18n from 'i18next'
import { sanitizeHtml, escapeText } from '../../utils/sanitize'

export const divider = (date) => {
  const dateTitle = new Date(date).toLocaleString(undefined, { dateStyle: 'medium' })
  const title = date === new Date().toDateString() ? i18n.t('ai.chat.today') : dateTitle
  return `<div class="divider d-flex align-items-center mb-4">
    <p class="text-center mx-3 mb-0" style="color: #a2aab7;">${title}</p>
  </div>`
}

const parseBody = (body) => {
  // Raw HTML (e.g. typing indicator) should not be parsed as markdown
  if (body.includes('typing-indicator')) return body
  return sanitizeHtml(marked.parse(body))
}

export const serializeMessage = (existingHtml, message) => {
  if (existingHtml.includes(`msg-${message.id}`)) {
    return ''
  }

  const data = {
    message,
    content: parseBody(message.body),
    time: new Date(message.created_at).toLocaleString(undefined, { timeStyle: 'short' }),
  }
  return message.user.id == window.appData.user.id ? messageMe(data) : messageOther(data)
}

const messageOther = ({ message, content, time }) => (
  `<div id="msg-${message.id}" class="d-flex flex-row justify-content-start">
    <div>
      <div class="d-flex align-items-center justify-content-between mb-1">
        <p class="small fw-bold mb-0">${escapeText(message.user.name)}</p>
        <button
          id="discard-message-${message.id}"
          data-action="click->chats--messages#discardMessageClick" data-message-id="${message.id}"
          type="button" class="btn-close text-muted fs-7"></button>
      </div>
      <div id="msg-content-raw-${message.id}" class="d-none">${escapeText(message.body)}</div>
      <div id="msg-content-${message.id}"
        class="small p-2 ms-3 mb-1 rounded-3 msg-other markdown-content">${content}</div>
      <div class="d-flex flex-row justify-content-between">
        <div class="small ms-3 mb-0 rounded-3 text-muted">${time}</div>
      </div>
    </div>
  </div>`
)

const messageMe = ({ message, content, time }) => (
  `<div id="msg-${message.id}" class="d-flex flex-row justify-content-end mb-2 text-end">
    <div>
      <div class="d-flex align-items-center justify-content-between mb-1">
        <p class="small fw-bold mb-0">${escapeText(message.user.name)}</p>
        <button
          id="discard-message-${message.id}"
          data-action="click->chats--messages#discardMessageClick" data-message-id="${message.id}"
          type="button" class="btn-close text-muted fs-7"></button>
      </div>
      <div id="msg-content-raw-${message.id}" class="d-none"></div>
      <div id="msg-content-${message.id}"
        class="small p-2 mb-1 rounded-3 msg-me markdown-content">${content}</div>
      <div class="d-flex flex-row justify-content-between">
        <div class="small ms-3 mb-0 rounded-3 text-muted">${time}</div>
      </div>
    </div>
  </div>`
)
